// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2w8uo","badges":"styles_badges__aNc_3"};